"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Google24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M11.9997 2.00067C14.3755 1.97256 16.674 2.82522 18.4515 4.38503L18.6906 4.60209L15.8357 7.45704C14.8032 6.47232 13.4253 5.93587 11.9997 5.95792C9.3909 5.95792 7.17528 7.71792 6.3853 10.0879C5.99865 11.2342 5.96891 12.4683 6.29607 13.6282L6.3853 13.9165C7.18263 16.2828 9.39457 18.0428 12.0033 18.0428C13.2481 18.0428 14.33 17.7485 15.1943 17.2235L15.402 17.089C16.3863 16.4359 17.0793 15.3929 17.3495 14.247L17.4009 14H11.9997V10H21.4316C21.5492 10.6687 21.6043 11.5502 21.6043 12.23C21.6043 15.1553 20.5988 17.6458 18.8392 19.3813L18.626 19.583C17.0431 21.048 14.8932 21.9218 12.349 21.995L11.9997 22C8.32381 22 4.95359 19.9856 3.20922 16.7707L3.06372 16.4922L2.91718 16.1876C1.69427 13.5317 1.69427 10.4727 2.91718 7.81677L3.06372 7.51215L3.20922 7.23337C4.95359 4.01503 8.32381 2.00067 11.9997 2.00067Z", fill: "#131416" }));
}
function Google24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Google24Svg, Object.assign({}, svgProps)));
}
exports.default = Google24;
//# sourceMappingURL=Google24.js.map